module.exports = __webpack_public_path__ + "img/luck-draw-bg.ef3389dd.png";